import { render, staticRenderFns } from "./VendorBadanUsahaGEMS.vue?vue&type=template&id=16aafd30&"
import script from "./VendorBadanUsahaGEMS.vue?vue&type=script&lang=js&"
export * from "./VendorBadanUsahaGEMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports